/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');

// Sliders
// require('./app/sliders/card-slider');

// ScrollTrigger
// require('./app/scrollTrigger');

// App Requires
require('./app/header');
require('./app/dropdowns');

require('./app/blocks/stats');
require('./app/blocks/history-tabs');
require('./app/blocks/blog');
require('./app/blocks/portfolio-search');
require('./app/blocks/quote-highlights');
require('./app/blocks/hero-intro');
require('./app/blocks/testimonials');
require('./app/blocks/callout');

$(() =>{
    $('[data-toggle="modal"]').on('click', function(){
        let target = $(this).data('target');
        $(target).modal('show');
    });

    $('[data-dismiss="modal"]').on('click', function(){
        let target = $(this).closest('.modal');
        target.modal('hide');
    });
});
